import { useReducer, useRef, useCallback } from 'react';
function isThunk(action) {
    return typeof action === 'function';
}
/**
 * Can be used the same way as useReducer, but allows functions to be passed as
 * actions (aka thunks).
 */
export function useThunkReducer(reducer, initialState, initializer) {
    const [state, dispatch] = useReducer(reducer, initialState, initializer);
    const previousState = useRef();
    previousState.current = state;
    const thunkedDispatch = useCallback(function thunkedDispatch(action) {
        if (isThunk(action)) {
            return action(thunkedDispatch, () => previousState.current);
        }
        dispatch(action);
    }, 
    // exhaustive-deps doesn't work with recursion
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return [previousState.current, thunkedDispatch];
}
//# sourceMappingURL=useThunkReducer.js.map